export default {
    
    isLogin(){
        return !localStorage.getItem('9manad_line_token') != undefined
    }
    ,setToken(token){
        localStorage.setItem('9manad_line_token',token)
    }
    ,getTokenHeader(){
        return {"Authorization" : "Bearer " + localStorage.getItem('9manad_line_token')}
    }
    ,setLang(lang){
        
        localStorage.setItem('9manad_line_lang',lang)
    }
    ,getLang(){
        var lang = localStorage.getItem('9manad_line_lang')
        if(!lang) lang =  process.env.VUE_APP_I18N_LOCALE || 'th'
        return lang
    }
}